import {
  Badge,
  Box,
  Button,
  Container,
  Flex,
  IconButton,
  Spinner,
} from '@theme-ui/components'
import { UserDTO, UsersResponse } from 'api'
import React, { useState } from 'react'
import { BsEye } from 'react-icons/bs'
import { useQuery } from 'react-query'
import { Link } from 'react-router-dom'
import { match } from 'ts-pattern'
import { useDebounce } from 'use-debounce'
import api from '../../api/api'
import { Table } from '../../components'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import { InputComponent } from '../../components/Input/Input'
import { PanelComponent } from '../../components/Panel/Panel'
import { LabeledSelect } from '../../components/Select/LabeledSelect'
import colors from '../../theme/colors'
import { humanize } from '../../utils'

export default function UsersPage() {
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('')
  const [filter] = useDebounce([search, status], 1000)
  const { data, isLoading } = useQuery(
    ['/users', ...filter],
    ({ queryKey }) => {
      const [_, search, status] = queryKey
      return api
        .get<UsersResponse>('/users', {
          params: {
            role: 'admin',
            'q[email_or_fname_or_lname_cont]': search,
            'q[status_eq]': status,
          },
        })
        .then((resp) => resp.data)
        .catch((err) => {
          throw err
        })
    }
  )
  const usersData = data?.data || []

  return (
    <Container sx={{ px: 4, py: 2 }}>
      <Box sx={{ mb: 3 }}>
        <Breadcrumb
          crumbs={[
            { label: 'Home', link: '/' },
            { label: 'Users', link: '/users' },
          ]}
        />
      </Box>

      <Box>
        <Flex sx={{ alignItems: 'end' }}>
          <InputComponent
            label="Cari"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Email atau nama"
          />
          <LabeledSelect
            label="Status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            placeholder="Status"
            sx={{ width: 6, ml: 2 }}
          >
            <option value=""></option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </LabeledSelect>
          <Box sx={{ ml: 'auto' }}>
            <Link to="/users/create">
              <Button>Tambah</Button>
            </Link>
          </Box>
        </Flex>
        <PanelComponent mt={3}>
          {match(isLoading)
            .with(true, () => (
              <Box sx={{ textAlign: 'center', py: 15 }}>
                <Spinner />
              </Box>
            ))
            .with(false, () => {
              return (
                <Table
                  options={{
                    initialState: {
                      pageSize: 10,
                    },
                    columns: [
                      { Header: 'Email', accessor: 'email' },
                      { Header: 'Firstname', accessor: 'fname' },
                      { Header: 'Lastname', accessor: 'lname' },
                      {
                        Header: 'Status',
                        Cell: ({ row }) => {
                          const status = row.original.status
                          const variant = {
                            active: 'success',
                            inactive: 'lightest',
                          }[status]
                          return (
                            <Badge variant={variant}>{humanize(status)}</Badge>
                          )
                        },
                      },
                      {
                        Header: 'Aksi',
                        id: 'action',
                        Cell: ActionCell,
                        width: '5%',
                        centered: true,
                      },
                    ],
                    data: usersData,
                  }}
                  totalData={data?.total}
                />
              )
            })
            .exhaustive()}
        </PanelComponent>
      </Box>
    </Container>
  )
}

function ActionCell(props) {
  const { id }: UserDTO = props?.row?.original || {}

  return (
    <Flex sx={{ alignItems: 'center' }}>
      <Link
        to={`/users/${id}`}
        style={{ textDecoration: 'none', color: `${colors.text}` }}
      >
        <IconButton>
          <BsEye size={45} />
        </IconButton>
      </Link>
    </Flex>
  )
}
